import React, { useEffect, useState } from "react";
import { Auth } from "@aws-amplify/auth";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import AppLayout from "../../layouts/AppLayout/AppLayout";
import { CircularProgress, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { customChallenge, customParametersUpdated } from "./custom-sso";
import useTitle from "../../helpers/use-title";

export default () => {
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const params = new URLSearchParams( location.search )
    const redirectUri = params.get( 'redirect_uri' ) as string
    const username = params.get( 'username' ) as string
    const source = params.get( 'source' ) as string
    const token = params.get( 'token' ) as string

    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();

    useTitle( t( 'please-wait' ) );

    useEffect(() => {
      dispatch( customParametersUpdated({
        username,
        source,
        token,
      }))
      dispatch( customChallenge() );
    }, []);

    return <AppLayout title={ t( 'SSO' ) }>
      <Grid container justifyContent={'center'}>
        <CircularProgress sx={ { mt: 15 } } />
      </Grid>
    </AppLayout>
}
